import { render, staticRenderFns } from "./proveedores.vue?vue&type=template&id=3d0a5b87&scoped=true&"
import script from "./proveedores.vue?vue&type=script&lang=ts&"
export * from "./proveedores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0a5b87",
  null
  
)

export default component.exports